const constants = require(`./${ ENV }`);

export default function (app) {
    Object.keys(constants)
        .forEach(key => {
            app.constant(key, constants[key]);
        });
}



// WEBPACK FOOTER //
// ./Client/app/common/constants/index.js